<template>
  <div>
      <background></background>
      <header></header>
  </div>
</template>
<script>
import Background from "@/components/components/Background";
export default {
  components:{
      'background':Background,
  } 
};
</script>
<style lang="scss">

</style>